export const baseUrl = "https://api-ekpay.eksquare.com/";
